// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__32yjK","content":"Consent_content__3vOKn","footer":"Consent_footer__1VHME"};